module.exports = __webpack_public_path__ + "static/img/A6106_test.4666417d.png";